import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/filters/filterOptions/styles.scss';export default {
  "optionsFilter": "_optionsFilter_1f393_1",
  "input": "_input_1f393_7",
  "toggleArrow": "_toggleArrow_1f393_25",
  "selectedOptions": "_selectedOptions_1f393_33",
  "placeholder": "_placeholder_1f393_42",
  "list": "_list_1f393_47",
  "item": "_item_1f393_61",
  "typeName": "_typeName_1f393_74",
  "opened": "_opened_1f393_81"
};